<template>
    <div>
        <b-row>
            <b-col>
                <b-input-group>
                    <template v-slot:prepend>
                        <b-input-group-text><i class="fa-solid fa-search"></i></b-input-group-text>
                    </template>
                    <b-form-input size="sm" placeholder="Search Flags" v-model="searchValue"></b-form-input>
                </b-input-group>
            </b-col>
        </b-row>
        <b-row>
            <b-col>
                <b-button size="sm" block variant="danger" :disabled="deletingAll" @click="removeAllItems">
                    <i v-if="deletingAll" class="ml-2 fa-regular fa-spin fa-spinner fa-fw"></i>
                    <i v-else class="fa-regular fa-times fa-fw"></i>
                    Clear All
                </b-button>
            </b-col>
        </b-row>
        <b-list-group class="list-group-accent tab-content">
            <LoadingSpinner class="mt-3" :busy="loading"/>
            <template v-if="!loading">
                <b-list-group-item v-for="(flag,index) in filteredFlags"
                                :class=" flag.stop_workflow == 1 ? 'list-group-item-accent-danger' : '' "
                                @click="flagSelected(flag,index)"
                                class="flag list-group-item-divider p-0 p-relative"
                                :key="flag.id">
                    <div class="d-flex">


                        <div class="d-flex pointer" @click="goToKitView(flag.flaggable_type == 'GoldExchange\\Models\\Order' ? flag.flaggable_id : flag.latest_order_id)">
                            <div class="flex-fill align-self-center py-2 pl-2" style="max-width: 30px; padding-left: 5px;">
                                <i class="fa-solid fa-circle flag-type-icon mr-2" :class="'flag-'+getVariant(flag.flag_type.config)"></i>
                            </div>

                            <div class="flex-fill py-2" v-if="flag.flaggable_type == 'GoldExchange\\Models\\Order'">
                                <strong>{{ flag.flag_type.name }}</strong>
                                <div class="text-muted small">Order ID: <strong>{{ flag.flaggable_id }}</strong></div>
                                <div class="text-muted small">Last Updated: <strong>{{ flag.updated_at | datetime }}</strong></div>
                            </div>

                            <div class="flex-fill py-2" v-if="flag.flaggable_type == 'GoldExchange\\Models\\Customer'">
                                <strong>{{ flag.flag_type.name }}</strong>
                                <div class="text-muted small">Customer ID: <strong>{{ flag.flaggable_id }}</strong></div>
                                <div class="text-muted small">Last Updated: <strong>{{ flag.updated_at | datetime }}</strong></div>
                            </div>
                        </div>



                        <div class="flex-fill text-right d-flex flex-column justify-content-between py-2 pr-2">
                            <div class="d-flex justify-content-end">
                                <b-badge v-b-tooltip.hover title="Follow Up Date" v-if="flag.follow_up" variant="warning">
                                    <i class="fa-solid fa-bell mr-1"></i>{{ flag.follow_up | datetime }}</b-badge>
                            </div>
                            <div>
                                <i v-b-tooltip.hover title="Priority"
                                class="fa-solid flag-alert-icons fa-star text-warning" v-if="flag.priority"></i>
                                <i v-b-tooltip.hover title="Has Notes"
                                class="fa-regular flag-alert-icons fa-clipboard-list text-info ml-1" v-if="flag.note"></i>
                                <i v-b-tooltip.hover title="Has Replies"
                                class="fa-solid flag-alert-icons fa-reply text-primary ml-1" v-if="flag.replies.length > 0"></i>
                                <i v-b-tooltip.hover title="Stop Workflow"
                                class="fa-solid flag-alert-icons fa-exclamation-triangle text-danger ml-1" v-if="flag.stop_workflow"></i>
                                <b-button v-if="!isDeleting(flag.id)" class="ml-2" @click="removeItem(flag.id)" size="sm"><i class="fa-regular fa-times"></i></b-button>
                                <i v-if="isDeleting(flag.id)" class="ml-2 fa-regular fa-spin fa-spinner"></i>
                            </div>
                        </div>
                    </div>
                </b-list-group-item>
            </template>
        </b-list-group>


    </div>
</template>

<script>
    import LoadingSpinner from '@/components/LoadingSpinner';
    import {
        SYNC_USER,
    } from '../store/actions';
    export default {
        components: {
            LoadingSpinner,
        },
        name: 'DefaultAside',
        data() {
            return {
                FlagEditIsOpen: false,
                searchValue:'',
                index: null,
                selectedFlag: null,
                flags: [],
                deleted: [],
                deletingAll: false,
                loaded: false,
                loading: false,
                profileCached: null,
            };
        },

        created() {

        },
        mounted() {
            //this.joinBroadcastChannel();
            this.getFlags();
        },
        beforeDestroy() {
            this.leaveBroadcastChannel();
        },
        methods: {
            goToKitView(id) {
                //this.$store.commit('updateUserFlagCount', this.flags.length);
                let path = '/kit/view/' + id;
                //kits view internally handles page swaps now, no need for go(0)
                this.$router.push({path: path});
            },
            // selected flag that is passed to edit modal
            flagSelected(flag, index) {
                this.selectedFlag = {
                    flag: flag,
                    index: index,
                };

                this.FlagEditIsOpen = true;
            },
            getVariant(config) {
                if(config) {
                    let decodedConfig = JSON.parse(config);
                    return decodedConfig.variant ? decodedConfig.variant : 'secondary';
                }
                return 'secondary';
            },
            getFlags() {
                if(!this.loaded) {
                    this.loading = true;
                    this.loaded = false;
                    this.$store.commit('updatingUserFlagsAsideDrawer', true);
                    this.$http.get('/users/flags').then((payload) => {
                        this.joinBroadcastChannel();
                        this.flags = payload.data.data;
                        this.$store.commit('updateUserFlagCount', this.flags.length);
                        this.loading = false;
                        this.loaded = true;
                        this.$store.commit('updatingUserFlagsAsideDrawer', false);
                    });
                    // let flaggable_type = 'GoldExchange\\Models\\Customer';
                    // let customerFlags = this.flags.filter(flag=> flag.flaggable_type == flaggable_type);
                }
            },
            removeItem(id) {
                this.deleted.push(id);
                this.$http.post('/users/flags/', {id: id}).then((payload) => {
                    this.flags = payload.data.data;
                    this.$store.commit('updateUserFlagCount', this.flags.length);
                });
            },
            removeAllItems() {
                this.$bvModal.msgBoxConfirm('This action will clear all your flag notifications. Are you sure you want to continue?', {
                    titleHtml: '<i class="fa-regular fa-exclamation-triangle fa-2xl fa-fw text-danger"></i> Please Confirm',
                    size: 'sm',
                    okVariant: 'danger',
                    okTitle: 'Clear All',
                    cancelTitle: 'Cancel',
                    hideHeaderClose: false,
                    centered: true
                    })
                    .then((value) => {
                        if (value === true) {
                            this.deletingAll = true;
                            const pluck = property => element => element[property];
                            this.deleted = this.flags.map(pluck('id'));
                            this.$http.post('/users/flags/all').then((payload) => {
                                this.deletingAll = false;
                                this.flags = payload.data.data;
                                this.$store.commit('updateUserFlagCount', this.flags.length);
                            });
                        }
                    })
                    .catch(() => {
                        this.deletingAll = false;
                    });

                
            },
            isDeleting(id) {
                return this.deleted.includes(id);
            },
            joinBroadcastChannel: function () {
                this.$store.dispatch(SYNC_USER, (profile) => {
                    console.info(String.fromCodePoint(0x1F514) + ' Joining App.Flag.Users.' + profile.id+ ' channel from DefaultAside.');
                    this.profileCached = profile;
                    this.$echo.channel('App.Flag.Users.' + profile.id)
                        .listen('FlagWasCreated', this.flagUpdatedCall)
                        .listen('FlagWasUpdated', this.flagUpdatedCall)
                        .listen('FlagWasCleared', this.flagUpdatedCall)
                        .listen('FlagWasDeleted', this.flagUpdatedCall)
                        .error((e) => {
                            console.log('ERROR OCCURRED', e);
                        });
                });
            },
            leaveBroadcastChannel: function() {
                if(this.profileCached) {
                    this.$echo.leaveChannel('App.Flag.Users.' + this.profileCached.id);
                }
            },
            flagUpdatedCall(payload) {
                let flag = payload.flag;
                let i;
                for(i = 0; i < this.flags.length; i++){
                    if(this.flags[i].id == flag.id) {
                        if(flag.deleted_at || flag.cleared_at) {
                            this.flags.splice(i,1);
                        } else {
                            this.flags[i] = flag;
                        }
                        this.$store.commit('updateUserFlagCount', this.flags.length);
                        this.$forceUpdate();
                        return;
                    }
                }
                if(!(flag.deleted_at || flag.cleared_at)) {
                    this.flags.push(flag);
                    this.$store.commit('updateUserFlagCount', this.flags.length);
                    this.$forceUpdate();
                }
            }
        },

        computed: {
            // flag search by flag type or order id
            filteredFlags() {
                let search = this.searchValue.toLowerCase();
                return this.flags.filter(flag => flag.flag_type.name.toLocaleLowerCase().includes(search) ||
                    (''+flag.flaggable_id).includes(search));
            },
            //fixme deprecated use here.
            _isFlagUpdated () {
                return this.$store.getters.updatedFlag;
            },
        },

        watch: {
            //fixme deprecated use here.
            _isFlagUpdated: {
                immediate: true,
                deep: true,
                handler() {
                    //this.getFlags();
                }
            }
        },
    };
</script>

<style scoped>
    .tab-content {
        height: calc(100vh - 116px);
        overflow: scroll;
    }
    .flag {
        border-left: 6px solid transparent;
    }
    .flag-type-icon {
        font-size: 12px !important;
    }
    .flag-alert-icons {
        font-size: 20px;
    }
    .list-group-item-accent-danger {
        border-left: 6px solid #f86c6b;
        background: #fff6f6;
    }
    .list-group-item-accent-danger:hover {
        background: #fff5f5;
    }
</style>


